import { Box, Modal, Tabs, Tab } from "@mui/material";
import React, { useEffect, useState } from "react";
import closeicon from "../../assets/images/close.svg";
import styles from "../../styles/common/bulkupload.module.css";
import generateExcel from "../../utils/excelFunctions";
import FileRead from "./FileRead";
import { postFile } from "../../utils/api";
import BulkUpload from "../../Pages/Scope1/StationaryCombustion.js/NaturalGas/BulkUpload";
import { mergeBulkUploadMatchRows } from "./BulkUploadModal";
import {
  mapNaturalGasBulkRows,
  mapStationaryBulkHoursRows,
  NATURAL_GAS_DENSITY_REQUIRED_UNITS,
} from "../../Pages/Scope1/StationaryCombustion.js/NaturalGas/naturalGasBulkRowNormalize";

/** True when at least one sheet has template rows (equipment from masters exists). */
const hasStationaryBulkTemplateRows = (data) => {
  if (!Array.isArray(data) || data.length === 0) return false;
  return data.some(
    (sheet) =>
      sheet &&
      Array.isArray(sheet.data) &&
      sheet.data.length > 0
  );
};

const StatioaryBulkUpload = ({
  onCloseBulkUpload,
  excelData,
  errorClose,
  setMatchData,
  setBulkUploadModal,
  isBulkUploadModal,
  fileName,
  url,
  setsnackOpen,
  matchedKey,
  setFormDataBulkUpload,
  setJsonBulkUpload = null,
  jsonBulkUpload,
  fetchData,
  setBulkUploadTable,
  bulkUploadTable,
  title,
  /** When true, uploaded file name must include the fuel/template name (e.g. Propane). */
  restrictBulkUploadFileNameToFuel = false,
}) => {
  const [errors, setErrors] = useState(null);
  const [file, setFile] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [showBulkUpload, setShowBulkUpload] = useState(false);
  const isNaturalGasFuel =
    String(fileName || "")
      .replace(/\s+/g, "")
      .toLowerCase() === "naturalgas";
  const isPropaneFuel =
    String(fileName || "")
      .replace(/\s+/g, "")
      .toLowerCase() === "propane";
  const isLPGFuel =
    String(fileName || "")
      .replace(/\s+/g, "")
      .toLowerCase() === "lpg";
  const fuelKey = String(fileName || "")
    .replace(/\s+/g, "")
    .toLowerCase();
  const isPetrolFuel =
    fuelKey === "petrol" || fuelKey === "petroleumgasoline";
  const useVolumetricBulkNormalize =
    isNaturalGasFuel || isPropaneFuel || isLPGFuel || isPetrolFuel;
  console.log(setJsonBulkUpload, "setMatchData");
  const handleDownload = async () => {
    if (!hasStationaryBulkTemplateRows(excelData)) {
      setsnackOpen({
        open: true,
        message:
          "There is no master data. Please add masters (e.g. industrial equipment) before downloading the template.",
        severity: "error",
      });
      return;
    }
    generateExcel(excelData, fileName);
  };

  const handleFileChange = (newFile) => {
    setFile(newFile);
    if (newFile) {
      setErrors(null);
    }
  };

  const handleSubmit = async () => {
    setIsSubmitted(true);
    if (!file) {
      setErrors("Please select a file");
    } else if (!url) {
      // alert("Error : Please provide url");
    } else {
      await postFile(url, file)
        .then((res) => {
          setsnackOpen({
            open: true,
            message: res.data.message,
            severity: "success",
          });
          onCloseBulkUpload();
        })
        .catch((err) => {
          // const errMessage = err.response?.data?.details
            // ?.map((el) => el?.error)
            // ?.join(",");
          console.log("errw", err?.response);
          if (err?.response?.status === 422) {
            const payload = err?.response?.data || {};
            // One row per Excel line (API may send one status per unique equipment)
            const cumulativeMatchData = mergeBulkUploadMatchRows(payload);
            const individualMatchData = mergeBulkUploadMatchRows({
              ...payload,
              excelData: payload.excelData1,
              equipmentStatusList: payload.equipmentStatusList1,
            });

            setMatchData([
              { type: "Cumulative", data: cumulativeMatchData },
              { type: "Individual", data: individualMatchData },
            ]);

            const pipe = (rows) =>
              (useVolumetricBulkNormalize ? mapNaturalGasBulkRows : mapStationaryBulkHoursRows)(
                rows || [],
              );
            const cumulativeJsonData = pipe(err?.response?.data?.excelData);
            const individualJsonData = pipe(err?.response?.data?.excelData1);

            setJsonBulkUpload &&
              setJsonBulkUpload([
                { type: "Cumulative", data: cumulativeJsonData },
                { type: "Individual", data: individualJsonData },
              ]);

            setFormDataBulkUpload([
              { type: "Cumulative", data: cumulativeJsonData },
              { type: "Individual", data: individualJsonData },
            ]);
            
            setBulkUploadModal(false);
            setShowBulkUpload(true);
            errorClose();
          }
          else if(err?.response?.status===400)
          {
              setBulkUploadModal(false);
              setsnackOpen({
                open: true,
                message:
                  err.response?.data?.error ?? "Network Error",
                severity: "error",
              });
              console.log("err", err);
            }
          else if(fetchData)
          fetchData();
         
        });
      
    }
  };

  useEffect(() => {
    if (!isSubmitted) return;
    if (file) {
      setErrors(null);
    } else {
      setErrors("Please select a file");
    }
  }, [file, isSubmitted]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleCloseBulkUpload = () => {
    setShowBulkUpload(false);
    setBulkUploadTable(false);
  };

  // If showing bulk upload table, render the tabbed interface
  if (showBulkUpload) {
    return (
      <Modal
        open={showBulkUpload}
        onClose={handleCloseBulkUpload}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "90%",
            maxWidth: "1200px",
            height: "90vh",
            backgroundColor: "white",
            borderRadius: "8px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={activeTab} onChange={handleTabChange}>
              <Tab label="Cumulative Data Entry" />
              <Tab label="Individual Data Entry" />
            </Tabs>
          </Box>
          
          <Box sx={{ flex: 1, overflow: "auto", p: 2 }}>
            {activeTab === 0 && (
              <BulkUpload
                matchData={setMatchData?.[0]?.data || []}
                onClose={handleCloseBulkUpload}
                onConfirm={() => {
                  setShowBulkUpload(false);
                  fetchData();
                }}
                setMatchData={setMatchData}
                bulkUploadTable={true}
                url={`/master/getAllIndustrialEquipment?fuelType=${fileName.toLowerCase()}`}
                setFormData={setFormDataBulkUpload}
                formData={setFormDataBulkUpload?.[0]?.data || []}
                fuelType={fileName}
                submitUrl={`/master/addIndustrialEquipment`}
                jsonBulkUpload={jsonBulkUpload || []}
                bulkUploadUrl={`/stationaryCombustion/${fileName.toLowerCase()}/jsonupload`}
                setsnackOpen={setsnackOpen}
                isTabbedData={true}
                activeTab={0}
                title="Cumulative"
                densityRequiredUnits={
                  useVolumetricBulkNormalize
                    ? NATURAL_GAS_DENSITY_REQUIRED_UNITS
                    : undefined
                }
              />
            )}
            
            {activeTab === 1 && (
              <BulkUpload
                matchData={setMatchData?.[1]?.data || []}
                onClose={handleCloseBulkUpload}
                onConfirm={() => {
                  setShowBulkUpload(false);
                  fetchData();
                }}
                setMatchData={setMatchData}
                bulkUploadTable={true}
                url={`/master/getAllIndustrialEquipment?fuelType=${fileName.toLowerCase()}`}
                setFormData={setFormDataBulkUpload}
                formData={setFormDataBulkUpload?.[1]?.data || []}
                fuelType={fileName}
                submitUrl={`/master/addIndustrialEquipment`}
                jsonBulkUpload={jsonBulkUpload || []}
                bulkUploadUrl={`/stationaryCombustion/${fileName.toLowerCase()}/jsonupload`}
                setsnackOpen={setsnackOpen}
                title="Individual"
                isTabbedData={true}
                activeTab={1}
                densityRequiredUnits={
                  useVolumetricBulkNormalize
                    ? NATURAL_GAS_DENSITY_REQUIRED_UNITS
                    : undefined
                }
              />
            )}
          </Box>
        </Box>
      </Modal>
    );
  }

  return (
    <Modal
      open={isBulkUploadModal}
      onClose={onCloseBulkUpload}
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "stretch",
      }}
    >
      <Box
        sx={{
          width: "40%",
          height: "100vh",
          display: "flex",
        }}
      >
        <div
          style={{
            width: "30px",
            height: "30px",
            backgroundColor: "white",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0.75rem",
            cursor: "pointer",
          }}
          onClick={onCloseBulkUpload}
        >
          <img src={closeicon} alt="close" />
        </div>
        <div className={styles.upload_div}>
          <p className={styles.heading}>Upload Data</p>
          <div className={styles.table_div}>
            <div className={styles.table_sub_div}>
              <p className={styles.sub_heading}>Step 1 : </p>
            </div>
            <div className={styles.table_sub_div_two}>
              <p className={styles.sub_heading}>
                Download the{" "}
                <span style={{ color: "rgba(72, 130, 87, 1)" }}>.excel</span>{" "}
                File
              </p>
              <p className={styles.comment_heading}>
                Kindly download the excel Template to Continue Filling Data
              </p>
            </div>
          </div>
          <button className={styles.download_button} onClick={handleDownload}>
            Click Here To Download
          </button>
          <div className={styles.table_div}>
            <div className={styles.table_sub_div}>
              <p className={styles.sub_heading}>Step 2 : </p>
            </div>
            <div className={styles.table_sub_div_two}>
              <p className={styles.sub_heading}>
                Fill The Sheet Document & Save
              </p>
              <p className={styles.comment_heading}>
                Fill the downloaded excel sheet & save it on local storage
              </p>
            </div>
          </div>
          <div className={styles.table_div}>
            <div className={styles.table_sub_div}>
              <p className={styles.sub_heading}>Step 3 : </p>
            </div>
            <div className={styles.table_sub_div_two}>
              <p className={styles.sub_heading}>
                Upload the Filled{" "}
                <span style={{ color: "rgba(72, 130, 87, 1)" }}>.excel</span>{" "}
                File
              </p>
              <p className={styles.comment_heading}>
                Kindly Upload The Saved Excel file here
              </p>
            </div>
          </div>
          <FileRead
            name="file"
            setFile={handleFileChange}
            errors={errors}
            accept=".csv,.xlsx,.xls"
            fileNameMustInclude={
              restrictBulkUploadFileNameToFuel ? fileName : null
            }
          />
          <div className={styles.button_container}>
            <button className={styles.submit_button} onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default StatioaryBulkUpload;
